import React from 'react';
import Lesson from '../Lesson';
import CoursePreview from '../CoursePreview';

import styled from 'styled-components';

import { DataContext } from '../DataProvider';

function CourseGrouping({ data }) {
  // const [isExpanded, setIsExpanded] = React.useState(false);
  const { selectedCourse, setSelectedCourse } = React.useContext(DataContext);
  const courses = data.COURSES;
  const title = data.TITLE;

  const courseGroupContents = (
    <>
      <GroupTitle>{title}</GroupTitle>
      <CourseIcons>
        {courses.map((item, index) => (
          <CoursePreview key={`${item.episode_number}-${index}`} data={item} />
        ))}
      </CourseIcons>
    </>
  );

  return <Group>{courseGroupContents}</Group>;
}

export default CourseGrouping;

const Group = styled.div`
  padding: 20px;
  margin-bottom: 30px;
  background-color: #efeeec;
  width: 978px;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
`;

const GroupTitle = styled.h1`
  font-size: 24px;
  margin-bottom: 10px;
`;

const CourseIcons = styled.ul`
  display: grid;
  grid-template-columns: repeat(3, 1fr); // Creates three columns
  gap: 20px; // Adjust the gap between grid items as needed
  padding: 0; // Removes default padding
  list-style-type: none; // Removes default list styling
`;
